export const menu = [
  {
    id: "1",
    name: "차트 요소 추가",
    items: [
      {
        id: "1_1",
        name: "축",
        items: [
          {
            id: "1_1_1",
            name: "기본 가로",
          },
          {
            id: "1_1_2",
            name: "기본 세로",
          },
          {
            id: "1_1_3",
            name: "다른 축 옵션",
            beginGroup: true,
          },
        ],
      },
      {
        id: "1_2",
        name: "축 제목",
        items: [
          {
            id: "1_2_1",
            name: "기본 가로",
          },
          {
            id: "1_2_2",
            name: "기본 세로",
          },
          {
            id: "1_2_3",
            name: "다른 축 제목 옵션",
            beginGroup: true,
          },
        ],
      },
      {
        id: "1_3",
        name: "차트 제목",
        items: [
          {
            id: "1_3_1",
            name: "없음",
          },
          {
            id: "1_3_2",
            name: "정렬",
          },
          {
            id: "1_3_3",
            name: "기타 제목 옵션",
            beginGroup: true,
          },
        ],
      },
      {
        id: "1_4",
        name: "데이터 레이블",
        items: [
          {
            id: "1_4_1",
            name: "없음",
          },
          {
            id: "1_4_2",
            name: "정렬",
          },
          {
            id: "1_4_3",
            name: "데이터 설명선",
          },
          {
            id: "1_4_4",
            name: "기타 데이터 레이블 옵션",
            beginGroup: true,
          },
        ],
      },
      {
        id: "1_5",
        name: "데이터 테이블",
        disabled: true,
      },
      {
        id: "1_6",
        name: "오차 막대",
        disabled: true,
      },
      {
        id: "1_7",
        name: "눈금선",
        items: [
          {
            id: "1_7_1",
            name: "기본 주 가로",
          },
          {
            id: "1_7_2",
            name: "기본 주 세로",
          },
          {
            id: "1_7_3",
            name: "기본 보조 가로",
          },
          {
            id: "1_7_4",
            name: "기본 보조 세로",
          },
          {
            id: "1_7_5",
            name: "다른 눈금선 옵션",
            beginGroup: true,
          },
        ],
      },
      {
        id: "1_8",
        name: "범례",
        items: [
          {
            id: "1_8_1",
            name: "없음",
          },
          {
            id: "1_8_2",
            name: "오른쪽",
          },
          {
            id: "1_8_3",
            name: "위쪽",
          },
          {
            id: "1_8_4",
            name: "왼쪽",
          },
          {
            id: "1_8_5",
            name: "아래쪽",
          },
          {
            id: "1_8_6",
            name: "기타 범례 옵션",
            beginGroup: true,
          },
        ],
      },
      // {
      //   id: "1_9",
      //   name: "추세선",
      // },
    ],
  },
  {
    id: "2",
    name: "빠른 레이아웃",
    disabled: true,
  },
  {
    id: "3",
    name: "데이터 선택",
    beginGroup: true,
  },
  // {
  //   id: "4",
  //   name: "데이터 편집",
  // },
  {
    id: "5",
    name: "차트 종류 변경",
    beginGroup: true,
  },
];

export const chartList = [
  {
    key: "Area Charts",
    items: [
      {
        value: "AREA",
        name: "Area",
      },
      {
        value: "SPLINE_AREA",
        name: "Spline Area",
      },
      {
        value: "STEP_AREA",
        name: "Step Area",
      },
    ],
  },
  {
    key: "Bar Charts",
    items: [
      {
        value: "STANDARD_BAR",
        name: "Standard Bar",
      },
      {
        value: "SIDE_BY_SIDE_BAR",
        name: "Side-by-Side Bar",
      },
      {
        value: "STACKED_BAR",
        name: "Stacked Bar",
      },
      // Drill-Down Chart
      {
        value: "FULL_STAKCED_BAR",
        name: "Full Stacked Bar",
      },
      {
        value: "SIDE_BY_SIDE_STACKED_BAR",
        name: "Side-by-Side Stacked Bar",
      },
      {
        value: "SIDE_BY_SIDE_FULL_STACKED_BAR",
        name: "Side-by-Side Full-Stacked Bar",
      },
      // Color Each Bar Differently
      /*
    {
      id: "BI_DIRECTIONAL_BAR",
      category: "Bar Charts",
      name: "Bi-Directional Bar",
    }, // Data: Positive/Negative
    */
      // Custom Annotations
      // Bullet Charts
    ],
  },
  {
    key: "Doughnut Charts",
    items: [
      {
        value: "DOUGHNUT",
        name: "Doughnut",
        // Custom Label in the Center
        // Financial Charts
      },
    ],
  },
  {
    key: "Line Charts",
    items: [
      {
        value: "LINE",
        name: "Line",
      },
      {
        value: "SPLINE",
        name: "Spline",
      },
      {
        value: "STEP_LINE",
        name: "Step Line",
      },
      // Logarithmic vs Linear Axes
    ],
  },
  {
    key: "Pie Charts",
    items: [
      {
        value: "PIE",
        name: "Pie",
      },
      // Pies with Equal Sizes
      // Pie with Annotations
    ],
  },

  // [Point Charts] Scatter
  // [Point Charts] Bubble
  // [Point Charts] Scatter Logarithmic Axis
  // [Point Charts] Custom Axis Position
  // [Polar and Radar Charts] Continuous Data
  {
    key: "Polar Charts",
    items: [
      {
        value: "POLAR",
        name: "Polar",
      },
      // Polar Chart with Annotations
    ],
  },
  // Range Charts
  // Sparkline Charts
  // Tree Map
  // Funnel and Pyramid Charts
  // Sankey Chart
  // Combinations
  // More Features
];

export const chartTypeList = {
  AREA: [
    {
      id: "area",
      name: "Area",
    },
    { id: "stackedarea", name: "Stacked Area" },
    { id: "fullstackedarea", name: "Full Stacked Area" },
  ],
  SPLINE_AREA: [
    {
      id: "splinearea",
      name: "Spline Area",
    },
    {
      id: "stackedsplinearea",
      name: "Stacked Spline Area",
    },
    {
      id: "fullstackedsplinearea",
      name: "Full Stacked Spline Area",
    },
  ],
  STEP_AREA: [{ id: "steparea", name: "Step Area" }],
  STANDARD_BAR: [
    {
      id: "bar",
      name: "Bar",
    },
  ],
  SIDE_BY_SIDE_BAR: [{ id: "bar", name: "Bar" }],
  STACKED_BAR: [
    {
      id: "stackedBar",
      name: "Stacked Bar",
    },
  ],
  FULL_STACKED_BAR: [
    {
      id: "fullstackedbar",
      name: "Full Stacked Bar",
    },
  ],
  SIDE_BY_SIDE_STACKED_BAR: [
    {
      id: "stackedBar",
      name: "Stacked Bar",
    },
  ],
  SIDE_BY_SIDE_FULL_STACKED_BAR: [
    {
      id: "fullstackedbar",
      name: "Full Stacked Bar",
    },
  ],
  BI_DIRECTIONAL_BAR: [
    {
      id: "stackedBar",
      name: "Stacked Bar",
    },
  ],
  DOUGHNUT: [
    {
      id: "doughnut",
      name: "Doughnut",
    },
  ],
  LINE: [
    {
      id: "line",
      name: "Line",
    },
    {
      id: "stackedline",
      name: "Stacked Line",
    },
    {
      id: "fullstackedline",
      name: "Full Stacked Line",
    },
  ],
  SPLINE: [
    { id: "spline", name: "Spline" },
    {
      id: "stackedspline",
      name: "Stacked Spline",
    },
    {
      id: "fullstackedspline",
      name: "Full Stacked Spline",
    },
  ],
  STEP_LINE: [{ id: "stepline", name: "Step Line" }],
  POLAR: [
    { id: "scatter", name: "Scatter" },
    { id: "line", name: "Line" },
    {
      id: "area",
      name: "Area",
    },
    {
      id: "bar",
      name: "Bar",
    },
    {
      id: "stackedbar",
      name: "Stacked Bar",
    },
  ],
};

export const fieldList = [
  {
    id: "APPLY_ENTP_NAME",
    name: "신청자: 임상시험 의뢰자",
  },
  {
    id: "RPRSV_NMP",
    name: "임상시험 대표자",
  },
  {
    id: "ADDR",
    name: "임상시험 소재지", // 시군구 구별이 필요할 듯
  },
  {
    id: "ORGN_DEV_BSSH_NM",
    name: "원개발사 명칭 (업체)",
  },
  {
    id: "ORGN_DEV_NATN_CD_NM",
    name: "개발사 국가",
  },
  {
    id: "HIST_REG_DT",
    name: "최종(변경)승인일자", // 범위설정이 필요할 듯
  },
  {
    id: "CLST_APRV_DT",
    name: "임상시험정보 승인일자", // 범위설정이 필요할 듯
  },
  {
    id: "APPROVAL_TIME",
    name: "승인일", // 범위설정이 필요할 듯
  },
  {
    id: "GOODS_NAME",
    name: "제품명",
  },
  {
    id: "PRDT_NM",
    name: "임상시험의약품 제품명 (코드명)",
  },
  {
    id: "GNRL_CD_NM",
    name: "임상시험의약품 성분명 (코드명)",
  },
  // {
  //   id: "CLINIC_EXAM_TITLE",
  //   name: "시험제목",
  // },
  // {
  //   id: "CLINIC_EXAM_ENG_TITLE",
  //   name: "임상시험제목 (영문)",
  // },
  // {
  //   id: "IVSGT_PURPS",
  //   name: "목적",
  // },
  {
    id: "CLST_PRPOS_CD_NM",
    name: "용도",
  },
  {
    id: "DMINT_DIVS_CD_NM",
    name: "국내/국외개발",
  },
  {
    id: "CLNC_TEST_DTL_CD_NM",
    name: "상세구분 (다국가)",
  },
  {
    id: "TRGT_DISS_CD_NM",
    name: "대상질환",
  },
  {
    id: "TRGT_DISS_DTL_CD_NM",
    name: "대상질환 상세",
  },
  // {
  //   id: "TRGT_DISS_DTL_ETC",
  //   name: "대상질환 기타 직접입력",
  // },
  // {
  //   id: "TRGT_DISS_NM",
  //   name: "대상질환명 (적응증)",
  // },
  {
    id: "DMST_PRMSN_YN",
    name: "임상시험용의약품 국내허가여부",
  },
  {
    id: "COMP_DRUG_YN",
    name: "임상시험용의약품 활성대조약여부",
  },
  {
    id: "FRST_INDV_TRGT_IVSGT_YN",
    name: "임상시험용의약품 최초사람대상여부",
  },
  {
    id: "CPDR_YN",
    name: "임상시험용의약품 대조약여부",
  },
  {
    id: "PLCB_YN",
    name: "임상시험용의약품 위약여부",
  },
  {
    id: "COMP_DRUG_NM",
    name: "임상시험용의약품 대조약제품명",
  },
  {
    id: "SHAPE_CD",
    name: "임상시험용의약품 제형",
  },
  {
    id: "CLINIC_STEP_NAME",
    name: "단계",
  },
  {
    id: "CLINIC_STEP_NM",
    name: "[연구설계] 임상단계",
  },
  {
    id: "CLINIC_TYPE_CD_NM",
    name: "[연구설계] 임상시험형태",
  },
  {
    id: "CLINICAL_PERIOD",
    name: "[연구설계] 기간",
  },
  {
    id: "TESTEE_CNT_INFO",
    name: "[연구설계] 목표대상자수 (국내 대상자수)", // 범위설정이 필요할 듯
  },
  {
    id: "RNDM_ASSG_CD_NM",
    name: "[연구설계] 무작위배정여부",
  },
  {
    id: "BLND_CD_NM",
    name: "[연구설계] 눈가림종류",
  },
  {
    id: "ARBTR_GRP_NUM",
    name: "[연구설계] 중재군수", // 범위설정이 필요할 듯
  },
  {
    id: "CLST_BGNG_DT",
    name: "[연구설계] 최초 시험대상자 선정일", // 범위설정이 필요할 듯
  },
  {
    id: "LAST_TRGTER_SLCTN_DT",
    name: "[연구설계] 최종 시험대상자 선정일", // 범위설정이 필요할 듯
  },
  {
    id: "CLST_END_DT",
    name: "[연구설계] 최종 시험대상자 관찰 종료일", // 범위설정이 필요할 듯
  },
  // {
  //   id: "TEST_COMPLETION_DT",
  //   name: "[연구설계] 실제 시험 완료일",
  // },
  // {
  //   id: "RESULT_REPORT_SUBMIT_DT",
  //   name: "[연구설계] 결과보고 제출일",
  // },
  // {
  //   id: "PRIM_EVL_VAR",
  //   name: "[수행 및 평가방법] 1차 유효성 평가변수",
  // },
  // {
  //   id: "SCND_EVL_VAR",
  //   name: "[수행 및 평가방법] 2차 유효성 평가변수",
  // },
  {
    id: "DOSAGE_TERM_TS",
    name: "[수행 및 평가방법] 투여기간",
  },
  // {
  //   id: "CLST_MTH_INFO",
  //   name: "[수행 및 평가방법] 투여방법",
  // },
  // {
  //   id: "STATUS",
  //   name: "진행현황",
  // },
  // {
  //   id: "HMPG_ADDR",
  //   name: "모집공고 확인 홈페이지 주소",
  // },

  // { id: "country", name: "country" },
  // { id: "y014", name: "y014" },
  // { id: "y1564", name: "y1564" },
  // { id: "y65", name: "y65" },
];

export const verticalAlignmentType = ["bottom", "top"];

export const horizontalAlignmentType = ["center", "left", "right"];

export const alignmentType = ["center", "left", "right"];

export const positionType = ["inside", "outside"];
